import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation, useTranslation } from 'react-i18next';

import { VerifyDeleteDialog } from 'components/Shared/VerifyDeleteDialog';
import {
  clearFetchingType,
  deleteNotificationsFromList,
  setActiveNotifications,
} from 'store/actions/notifications';
import { FETCHING_STATUS, FETCHING_TYPE } from 'store/reducers/notifications';

var DeleteNotificationPopup = function(props) {
  var open = props.open;
  var closePopup = props.closePopup;
  var deleteNotificationsFromList = props.deleteNotificationsFromList;
  var activeNotificationUUID = props.activeNotificationUUID;
  var notificationsList = props.notificationsList;
  var isFetching = props.isFetching;
  var clearFetchingType = props.clearFetchingType;
  var currentAccountUUID = props.currentAccountUUID;

  var { t } = useTranslation();
  var nameState = useState('');
  var nameOfNotification = nameState[0];
  var setNameOfNotification = nameState[1];

  // Get notification name when activeNotificationUUID changes
  useEffect(function() {
    if (notificationsList && activeNotificationUUID) {
      var notification = notificationsList.find(function(n) {
        return n.uuid === activeNotificationUUID;
      });
      if (notification) {
        setNameOfNotification(notification.columns[0].value);
      }
    }
  }, [activeNotificationUUID, notificationsList]);

  // Handle successful deletion
  useEffect(function() {
    if (
      isFetching.status === FETCHING_STATUS.success &&
      isFetching.type === FETCHING_TYPE.deletingNotification
    ) {
      clearFetchingType();
      closePopup();
    }
  }, [isFetching, clearFetchingType, closePopup]);

  // Reset state when dialog closes
  useEffect(function() {
    if (!open) {
      setActiveNotifications('');
    }
  }, [open]);

  var handleConfirm = useCallback(function(data) {
    deleteNotificationsFromList({
      activeNotificationUUID: activeNotificationUUID,
      currentAccountUUID: currentAccountUUID,
      value: data.name,
    });
  }, [deleteNotificationsFromList, activeNotificationUUID, currentAccountUUID]);

  var isDeleting = isFetching.status === FETCHING_STATUS.inProgress &&
    isFetching.type === FETCHING_TYPE.deletingNotification;

  return (
    <VerifyDeleteDialog
      open={open}
      onClose={closePopup}
      onConfirm={handleConfirm}
      itemName={nameOfNotification}
      itemType={t('notificationsPage:notification')}
      title={t('notificationsPage:deleteNotificationPopup:title')}
      message={t('notificationsPage:deleteNotificationPopup:message', { name: nameOfNotification })}
      isFetching={isDeleting}
    />
  );
};

DeleteNotificationPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  closePopup: PropTypes.func.isRequired,
  currentAccountUUID: PropTypes.string.isRequired,
  deleteNotificationsFromList: PropTypes.func.isRequired,
  activeNotificationUUID: PropTypes.string,
  notificationsList: PropTypes.array,
  isFetching: PropTypes.object.isRequired,
  clearFetchingType: PropTypes.func.isRequired,
};

DeleteNotificationPopup.defaultProps = {
  activeNotificationUUID: '',
  notificationsList: [],
};

var mapStateToProps = function(state) {
  return {
    activeNotificationUUID: state.notifications_page.activeNotificationUUID,
    notificationsList: state.notifications_page.listOfNotifications,
    isFetching: state.notifications_page.isFetching,
  };
};

var mapDispatchToProps = {
  setActiveNotifications: setActiveNotifications,
  deleteNotificationsFromList: deleteNotificationsFromList,
  clearFetchingType: clearFetchingType,
};

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(DeleteNotificationPopup),
  ),
);
